export const validateAllFieldSets = (
  ...fs: {
    makeAllValidate: () => void;
  }[]
) => {
  return fs.forEach((f) => f.makeAllValidate());
};
